var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [_vm._v(" Filters ")]),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c("li", [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.itemNo,
                      expression: "value.itemNo",
                    },
                  ],
                  staticClass: "input is-capitalized",
                  attrs: { type: "text", placeholder: "Item No." },
                  domProps: { value: _vm.value.itemNo },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "itemNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.itemDesc,
                      expression: "value.itemDesc",
                    },
                  ],
                  staticClass: "input is-capitalized",
                  attrs: { type: "text", placeholder: "Description" },
                  domProps: { value: _vm.value.itemDesc },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "itemDesc", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.type,
                          expression: "value.type",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "", selected: "" } }, [
                        _vm._v("-- Type --"),
                      ]),
                      _c(
                        "option",
                        { domProps: { value: _vm.itemTypeEnum.LABOUR } },
                        [_vm._v("Labour")]
                      ),
                      _c(
                        "option",
                        { domProps: { value: _vm.itemTypeEnum.PARTS } },
                        [_vm._v("Parts")]
                      ),
                      _c(
                        "option",
                        { domProps: { value: _vm.itemTypeEnum.OPG } },
                        [_vm._v("OPG")]
                      ),
                      _c(
                        "option",
                        { domProps: { value: _vm.itemTypeEnum.MISC } },
                        [_vm._v("Misc")]
                      ),
                      _c(
                        "option",
                        { domProps: { value: _vm.itemTypeEnum.SUBL } },
                        [_vm._v("Sublet")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.status,
                          expression: "value.status",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "status",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "2", selected: "" } }, [
                        _vm._v("-- Status --"),
                      ]),
                      _c("option", { domProps: { value: 1 } }, [
                        _vm._v("Standard"),
                      ]),
                      _c("option", { domProps: { value: 0 } }, [
                        _vm._v("Custom"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("hr"),
        _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.onFilterClick },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
                _c("span", [_vm._v("Filter")]),
              ]
            ),
          ]),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onResetClick } },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                ]),
                _c("span", [_vm._v("Reset")]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }